import { FC, useContext, useEffect } from "react";

import { AuthContext } from "src/context/authContext";
import { changeForNewExpiry } from "src/helpers/retreatment";
import useFetch from "src/hooks/useFetch";
import { createUserAPIResponseType } from "src/pages/createUser/types";
import { APIEndpoints } from "src/types/apiTypes";


const RetreatmentRenewalModal: FC<{ isModalVisible: boolean; hideModal: () => void; }> = ({ isModalVisible, hideModal }): JSX.Element => {
  const { userData, updateUserData } = useContext(AuthContext)

  const { loading: userLoading, data: updateUserApiResponse, mutate: addNewUser, error, removeErrorAndData } =
    useFetch<createUserAPIResponseType>(APIEndpoints.USER_UPDATE, {}, { userId: userData?.id });

  useEffect(() => {
    if (updateUserApiResponse) {
      console.log({ updateUserApiResponse })
      changeForNewExpiry()
      if (userData) updateUserData({ ...userData, retreatment_reminders: false })
      hideModal()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateUserApiResponse])

  const submitForm = () => {
    if ((error && error.length > 0) || updateUserApiResponse) removeErrorAndData();
    addNewUser({ user: { retreatment_reminders: false } });
  };


  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''}`}
      id="retreatmentRenewalModal"
      tabIndex={-1}
      data-bs-backdrop="true"
      aria-hidden="true"
      onClick={hideModal}
    >
      <div className="modal-dialog modal-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <p className="modal-title fs-3" aria-labelledby="retreatmentRenewalModalLabel">
              Retreatment Reminders are Here!
            </p>
            <button type="button" className="btn-close" aria-label="Close" onClick={hideModal}></button>
          </div>
          <div className="modal-body">
            <p className="h3 text-primary">
              Starting March 28th, Patient Retreatment Post card reminders will be mailed to your patients to 
              follow-up with your office for possible retreatment 6 months after submission. If you wish to 
              disable these reminders, you may click the ‘Turn off Automatic Reminders’ button below or in your 
              user account settings by 6PM Eastern on March 26th.
            </p>

            <div className="row pb-2">
              <div className="col-md-6">
                <a href="/assets/retreatments.mp4" target="_blank" className="btn btn-primary w-100">Learn More</a>
                <small>Click here to watch a brief video about the feature</small>
              </div>
              <div className="col-md-6">
                <button 
                  className="btn btn-primary w-100" type="button"
                  disabled={userLoading}
                  onClick={submitForm}
                >
                  Turn off Automatic Reminders
                </button>
                <small>
                  Turning off automatic reminders will prevent any patient from receiving a reminder when they are 
                  eligible for retreatment. If you wish to activate this later, you may do so under your user account 
                  settings at the top right.
                </small> 
              </div>      
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default RetreatmentRenewalModal
